import { FileRequest } from '@/generated/api';
import { Material, Technology } from '@/generated/types';

export enum DemandType {
  oneOff = 'oneOff',
  batches = 'batches',
}

export enum AcceptedFiles {
  PDF = 'PDF',
  STP = 'STP',
  STEP = 'STEP',
}

export interface UploadedFiles {
  stepFileToken: string;
  pdfFileToken?: string;
  size?: number;
}

export interface AnalyzedPart {
  id: string;
  stepFileToken?: string;
  stepFilename?: string;
  stepUrl?: string;
  stepPublicUrl?: string;
  pdfFileToken?: string;
  pdfFilename?: string;
  pdfUrl?: string;
  pdfPreviewImg?: string;
  imageUrl?: string;
  glbUrl?: string;
  technologies: Pick<Technology, 'id'>[];
  materials: Material[];
  tolerances: string[];
  metrologyMachineRequired?: boolean;
  certificationsRequired?: boolean;
  surfaceTolerances: string[];
  surfaceTreatments: string[];
  dimensionsMm: [number, number, number] | [];
  volumeCm3: number;
  weightGr?: number;
  turningLengthMm?: number;
  turningDiameterMm?: number;
  quantity: number;
  size?: number;
  targetWorkpieceId?: string;
}

export interface AnalyzedPartNamed extends AnalyzedPart {
  name: string;
}

export interface Workpiece {
  id: string;
  name: string;
  quantities: number[];
  technologies: Pick<Technology, 'id'>[];
  materials: Material[];
  dimensionsMm: [number, number, number] | [];
  files: AnalyzedPartNamed[];
  showTechnologiesBadge: boolean;
  showMaterialsBadge: boolean;
  showDimensionsBadge: boolean;
  assemblyPartFiles?: FileRequest[];
}

export interface WorkingPart {
  id: string;
  files: Partial<UploadedFiles> | Partial<UploadedFiles>[];
  analyzedPart?: AnalyzedPart;
  batchSizes: number[];
  nbBatches: number;
  hasFollowUpOrders: boolean;
  demandType: DemandType;
  size?: number;
}

export type WorkingPartsMap = Record<string, WorkingPart>;

export enum ManufacturerFlags {
  ON_ORDERFOX = 'onOrderfox',
  AUDITED_BY_ORDERFOX = 'auditedByOrderfox',
  TIER_THREE_PAID_MEMBER = 'TIER3',
  TIER_TWO_PAID_MEMBER = 'TIER2',
  TIER_ONE_PAID_MEMBER = 'TIER1',
  TIER_ZERO_PAID_MEMBER = 'TIER0',
  BOOKMARKED = 'bookmarked',
}

export * from './search';
